/**
 *
 * Qlist
 *
 */

import { mapGetters } from 'vuex';

import TrackerButton from '@/components/TrackerButton.vue';

export default {
  name: 'QaQtypeNav',

  components: {
    TrackerButton,
  },

  computed: {
    ...mapGetters('QA/QuestionList', {
      mg_myQuestionsCount: 'myQuestionsCount',
      mg_myAnswersCount: 'myAnswersCount',
      mg_myFollowsCount: 'myFollowsCount',
      mg_myQuestionsMarkedUnread: 'myQuestionsMarkedUnread',
      mg_myFollowsMarkedUnread: 'myFollowsMarkedUnread',
      mg_myAnswersMarkedUnread: 'myAnswersMarkedUnread',
    }),
  },

  methods: {
    makeQuestionUrlParamsAndGo(params) {
      this.$emit('qtype-change', params);
    },

    selectQtype(qType) {
      this.makeQuestionUrlParamsAndGo({
        qType,
        pageNo: 0,
      });
    },
  },
};
